<!-- Logo Navbar header Start -->
<header id="topnav" class="sticky shadow-sm">
  <div *ngIf="buyerPages && !authenticated">
    <div class="text-center py-2 bg-primary" *ngIf="!publicPayment">
      <a routerLink="/signup" [queryParams]="{ref: 'ektop'}" class="text-white" >
        {{ 'Buyer.SellerAnnouncement' | translate }}
        <span class="btn btn-outline-white ms-2 px-3 py-1">
          {{ 'Buyer.SignupSeller' | translate }}
        </span>
      </a>
    </div>
  </div>
  <div class="container">
    <div class="row mx-0 justify-content-between align-items-center">
      <div class="col-auto">
        <!-- Logo container-->
        <a class="logo" routerLink="/">
          <img *ngIf="currentLanguages == 'en'" src="../../assets/images/easykash-logo.png" alt="Logo" height="45px">
          <img *ngIf="currentLanguages == 'ar'" src="../../assets/images/easykash-logo-Ar.png" alt="Logo" height="45px">
        </a>
      </div>
      <div class="col-auto seller-menu" *ngIf="isSeller">
        <a class="me-3" routerLink="/seller/dashboard">
          {{ 'Sellers.Dashboard.Dashboard' | translate }}
        </a>
        <a class="me-3" routerLink="/seller/referrals">
          {{ 'Sellers.Dashboard.InviteEarn' | translate }}
        </a>
        <a class="me-3" href="https://play.google.com/store/apps/details?id=com.EasyKash">
          {{ 'Sellers.Dashboard.DownloadEasyKash' | translate }}
        </a>
      </div>
      <div class="col-auto">
        <button mat-button [matMenuTriggerFor]="menu" class="btn">
          <span>
            <svg width="20" height="20" viewBox="0 0 20 20" class="global-icon">
              <path fill="#0f75bc"
                d="M17.071 2.929C15.182 1.04 12.671 0 10 0 7.329 0 4.818 1.04 2.929 2.929 1.04 4.818 0 7.329 0 10c0 2.671 1.04 5.182 2.929 7.071C4.818 18.96 7.329 20 10 20c2.671 0 5.182-1.04 7.071-2.929C18.96 15.182 20 12.671 20 10c0-2.671-1.04-5.182-2.929-7.071zM8.103 1.378c-.335.326-.697.715-1.06 1.167-.627.783-1.15 1.625-1.558 2.511H2.689c1.249-1.84 3.174-3.186 5.414-3.678zM2.02 6.228H5.02c-.341 1.02-.54 2.087-.592 3.186H1.192c.074-1.133.364-2.208.827-3.186zm-.827 4.358h3.236c.052 1.099.25 2.166.592 3.186h-3c-.464-.978-.754-2.053-.828-3.186zm1.497 4.358h2.796c.408.885.93 1.728 1.558 2.51.362.453.725.842 1.06 1.168-2.24-.492-4.165-1.838-5.414-3.678zm6.725 3.29c-.417-.36-.936-.863-1.457-1.512-.455-.568-.845-1.162-1.17-1.778h2.627v3.29zm0-4.462H6.26c-.381-1.009-.6-2.073-.658-3.186h3.813v3.186zm0-4.358H5.601c.057-1.113.277-2.177.658-3.186h3.155v3.186zm0-4.358H6.787c.318-.604.699-1.185 1.142-1.743.528-.663 1.059-1.178 1.485-1.546v3.29zm9.394 4.358h-3.236c-.052-1.099-.25-2.166-.592-3.186h3c.464.978.754 2.053.828 3.186zm-1.497-4.358h-2.796c-.408-.885-.93-1.728-1.558-2.51-.362-.453-.725-.842-1.06-1.168 2.24.492 4.165 1.838 5.414 3.678zm-6.725-3.29c.417.36.936.863 1.457 1.512.455.568.845 1.162 1.17 1.778h-2.627v-3.29zm0 4.462h3.155c.381 1.009.6 2.073.658 3.186h-3.813V6.228zm0 4.358h3.813c-.057 1.113-.277 2.177-.658 3.186h-3.155v-3.186zm0 7.647v-3.29h2.627c-.318.605-.699 1.186-1.142 1.744-.528.663-1.059 1.178-1.485 1.546zm1.31.39c.336-.327.699-.716 1.061-1.168.628-.783 1.15-1.625 1.558-2.511h2.796c-1.249 1.84-3.174 3.186-5.414 3.678zm6.085-4.851H14.98c.341-1.02.54-2.087.592-3.186h3.236c-.074 1.133-.364 2.208-.827 3.186z">
              </path>
            </svg>
            <span class="lang-name">{{currentLanguages.toUpperCase()}}</span>
          </span>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item *ngFor="let lang of languages"
            (click)="changeLanguage(lang)">{{lang.toUpperCase()}}</button>
        </mat-menu>
      </div>
    </div>
  </div>
</header>
